'use client';

import React from "react";

// Import components needed for the page layout
import HeroSection from "./HeroSection";
import BrandsWrapper from "./BrandsWrapper";
import TransformMeetingsSection from "./TransformMeetingsSection";
import DetailedFeatureSection from "./DetailedFeatureSection";
import StatsSection from "./StatsSection";
import Testimonials from "@/components/ui/testimonials"; 
import CTASection from "./CTASection";

// This component contains the client-side logic and main page structure
export default function WhyMeetminutesClient() {
  return (
    <div className="bg-[#121212] text-white font-sans relative overflow-hidden">
      <div className="absolute top-[-100px] left-[-100px] w-[500px] h-[500px] rounded-full bg-blue-500/5 blur-[120px] pointer-events-none"></div>
      <div className="absolute bottom-[-100px] right-[-100px] w-[500px] h-[500px] rounded-full bg-indigo-500/5 blur-[120px] pointer-events-none"></div>
      
      <div className="container mx-auto px-4 py-16 md:py-24 pb-0 relative"> 
        <HeroSection />
        <BrandsWrapper />
        <TransformMeetingsSection />
        <DetailedFeatureSection />
        <StatsSection />
        <Testimonials useNeutralBackground={true} backgroundColor="#121212" /> 
      </div>
      
      <CTASection />
    </div>
  );
} 